{
  "all-listings": {
    "disconnected": {
      "text": "Créé ton compte ou connecte-toi pour voir les ressources disponibles dans le réseau Partage Agricole."
    },
    "needLogin": {
      "secondLine": "Créé ton compte ou connecte-toi pour voir les ressources disponibles dans le réseau Partage Agricole."
    },
    "empty": {
      "offer": {
        "firstLine": "Débute ton aventure ici !",
        "primaryButtonText": "Publie une offre !",
        "secondLine": "Participe au catalogue en offrant des objets à prêter."
      },
      "invite": {
        "primaryButtonText": "Invite les autres membres",
        "secondLine": "Invite des membres ou publie une offre dans ton quartier."
      }
    },
    "banner": {
      "xmas": {
        "text": "Les Fêtes arrivent ! Aide les autres membres à trouver ces objets souvent demandés."
      }
    },
    "inviteOthersPrompt": {
      "ctaButton": "Invite les autres membres"
    },
    "postOfferPrompt": {
      "firstAfter": {
        "button": "Inviter les autres membres",
        "title": "Invite les autres membres !"
      },
      "third": {
        "title": "Demande aux autres membres"
      }
    }
  },
  "common": {
    "appName": "Partage Agricole",
    "appDownloadPrompt": {
      "guest": "Tu aimes ce que tu vois? Retrouve Partage Agricole sur ton téléphone et reçois les nouvelles disponibilités près de chez toi",
      "qrCodeAccessibilityLabel": "Code QR pour télécharger l’application Partage Agricole"
    }
  },
  "contact-information": {
    "prompt": "Ajoutez le code postal de l'entreprise afin de voir quels objets sont disponibles à proximité.",
    "title": "Votre adresse",
    "prompt-public": "Ajoutez votre code postal afin de voir les annonces disponibles à proximité.",
    "title-public": "Ton code postal"
  },
  "contact-us": {
    "firstParagraph": "Le service aux membres de Partage Agricole est accessible par courriel et messagerie. Nous te répondrons le plus rapidement possible.",
    "faqLink": "https://www.partageagricole.ca/faq",
    "chatPrompt": {
      "bugReport": "Salut\u00A0!\u00A0😊\n\nMerci de nous expliquer ce qui ne va pas.",
      "suggestion": "Salut\u00A0!\u00A0😊\n\nOn est toujours ouverts aux suggestions. Merci de nous aider à améliorer notre service.\n\nMerci\u00A0!"
    }
  },
  "credentials": {
    "activationCodeFieldHelp": "Seuls les partenaires de Partage Agricole peuvent utiliser cette application. Pour obtenir le code d'invitation, contactez <a>Partage Agricole</a>.",
    "activationCodeFieldHelpLink": "https://www.partageagricole.ca/s-inscrire"
  },
  "guidelines": {
    "fifthParagraph": "Ne pas utiliser Partage Agricole pour vendre des objets.",
    "startingKit": "Je veux recevoir la <startingKitLink>Trousse de départ</startingKitLink> par la poste pour recruter les autres membres (optionnel)"
  },
  "impact": {
    "levels": {
      "0": {
        "description-completed": "Rejoint Partage Agricole",
        "title": "Explorateur"
      }
    }
  },
  "introModal": {
    "title": "Cher {{name}},",
    "first": "Merci de rejoindre la communauté et faire un premier pas vers la réduction de ta consommation et la création de nouveaux liens !",
    "second": "<strong>Partager est une preuve de confiance</strong> : plus vous prêtez, plus les autres auront envie de vous prêter !",
    "third": "<strong>Sache que moins de 0,1% de tous les partages</strong> engendrent un bris. Et ce n’est pas de mauvaise foi. C’est juste normal quand les objets sont un peu plus utilisés.",
    "notInsurable": {
      "community": "<strong>C’est l’occasion parfaite pour faire connaissance avec les autres membres</strong>, et faire un pas vers un monde durable."
    },
    "welcome": {
      "withWho": {
        "enterprise": "tes collègues et les autres membres",
        "municipal": "les autres membres",
        "municipal_closed": "les autres membres",
        "realestate": "les autres membres"
      }
    }
  },
  "my-information": {
    "firstNameFieldLabel": "Nom de l'entreprise",
    "credentialInformationTitle": "Compte et sécurité",
    "personalInformationTitle": "Informations du profil"
  },
  "my-personal-information": {
    "firstNameFieldLabel": "Nom de l'entreprise",
    "firstNameFieldPlaceholder": "ex. Ferme de la Tour d'Argent",
    "title": "Informations du profil"
  },
  "my-plan": {
    "businessPlan": {
      "firstParagraph": {
        "enterprise": "Votre abonnement à cette application de mutualisation est une gracieuseté de Partage Agricole."
      },
      "title": {
        "enterprise": "Abonnement Partage Agricole"
      }
    },
    "noEnd": "Cet abonnement est valide tant que vous êtes membre Partage Agricole.",
    "design": {
      "freeBorrowDescription": "Emprunte ton premier objet aux autres membres gratuitement",
      "unlimitedLendingDescription": "Publie des offres et prête tes objets aux autres membres autant de fois que tu le souhaites"
    }
  },
  "new": {
    "itemInformationSection": {
      "nameFieldPlaceholder": "ex: Tracteur de jardin",
      "descriptionFieldPlaceholder": {
        "offer": "Marque, dimensions, couleur, poids, état, année d’acquisition, conditions d’emprunt, spécificités de l’objet ...",
        "request": "Marque, dimensions, couleur, poids, état, année d’acquisition, conditions d’emprunt, spécificités de l’objet ..."
      }
    }
  },
  "notifications": {
    "introModal": {
      "intro": {
        "title": "Bienvenue dans le club",
        "body": "Découvre Partage Agricole !"
      }
    },
    "welcome": "Bienvenue sur Partage Agricole !",
    "welcomeMessage": "Merci de nous faire confiance.",
    "rate": {
      "borrower": {
        "message": "Votre avis est important pour nous et pour les autres membres de Partage Agricole."
      },
      "lender": {
        "message": "Votre avis est important pour nous et pour les autres membres de Partage Agricole."
      }
    },
    "loanReciprocity": {
      "message": "Publie les objets que tu utilises peu et fais-en profiter les autres membres."
    }
  },
  "offerAvailability": {
    "refrainPopup": {
      "hi": "Cher membre,",
      "text": {
        "lender": {
          "before": "N’oubliez pas de réserver vos dates de travaux et planifier vos journées de transport lors de votre réservation.",
          "after": "N’oubliez pas de réserver vos dates de travaux et planifier vos journées de transport."
        },
        "borrower": "N’oubliez pas de planifier vos journées de transport lors de votre emprunt."
      }
    }
  },
  "one-listing": {
    "needFoundModal": {
      "step2": {
        "gotoSelectLender": "Le besoin a été comblé sur Partage Agricole"
      }
    }
  },
  "personal-information": {
    "firstNameFieldLabel": "Nom de l'entreprise",
    "firstNameFieldPlaceholder": "ex. Ferme de la Tour d'Argent",
    "pictureFieldSubtitle": "Cette image sera affichée dans vos annonces et votre profil.",
    "pictureFieldTitle": "Ajouter une image du logo de l'entreprise",
    "title": "Informations du profil",
    "firstNameFieldLabel-public": "Prénom",
    "firstNameFieldPlaceholder-public": "Prénom",
    "lastNameFieldLabel-public": "Nom",
    "lastNameFieldPlaceholder-public": "Nom",
    "phoneFieldLabel-public": "Numéro de téléphone (optionnel)",
    "pictureFieldSubtitle-public": "La photo de profil augmente la confiance entre membres",
    "pictureFieldTitle-public": "Ajouter une photo de profil",
    "title-public": "Vos informations personnelles"
  },
  "privacy": {
    "link1": "https://www.partageagricole.ca/termes-et-conditions",
    "link2": "https://www.partage.club/politique-de-confidentialite",
    "line3": "de Partage Agricole."
  },
  "quick-new-thanks": {
    "bodyText": "Vous venez de contribuer à enrichir le catalogue de <strong>Partage Agricole</strong> ! \n\nVous pouvez modifier vos offres à tout moment dans votre centre de partage."
  },
  "ratings": {
    "notGreat": {
      "ctaButton": "Contacter Partage Agricole"
    }
  },
  "tutorial": {
    "multipleOffers": {
      "step1": {
        "text": "En offrant vos objets, vous encouragez même les horticulteur·trice·s les plus timides à demander."
      }
    },
    "publishOffers": {
      "step2": {
        "text": "En offrant tes objets, tu encourages même <strong>les autres membres les plus timides</strong> à demander. Tu peux toujours prêter tes objets, <strong>même sans abonnement</strong>.\n\nAppuie sur l’icône pour continuer. (2/5)"
      },
      "step2AltCorp": {
        "text": "En offrant tes objets, tu encourages même <strong>les autres membres les plus timides</strong> à demander.\n\nAppuie sur l’icône pour continuer. (2/5)"
      }
    }
  },
  "free-sub": {
    "inviteButtonText": "Inviter les autres membres",
    "spreadTheLoveText": "Parle-en aux autres membres pour qu’eux.elles aussi puissent profiter de l’offre spéciale !"
  },
  "help": {
    "borrower": {
      "steps": {
        "catalog": {
          "text": "Cherche un objet dans le catalogue ou crée un besoin visible par les autres membres"
        },
        "meeting": {
          "text": "Propose et confirme des dates d'emprunt et de ramassage avec l’autre membre"
        },
        "pickup": {
          "text": "Rencontre l’autre membre à son domicile ou dans un lieu public sécuritaire. <strong>Aucun échange d'argent, c'est gratuit !</strong>"
        }
      }
    },
    "guestCta": {
      "text": "Rejoins les autres membres et découvre tout ce que tu peux emprunter près de chez toi."
    },
    "lender": {
      "steps": {
        "share": {
          "text": "Rencontre l’autre membre à ton domicile ou dans un lieu public sécuritaire pour lui donner l'objet. <strong>Aucun échange d'argent, c'est gratuit !</strong>"
        }
      }
    }
  },
  "invite": {
    "referralProgram": {
      "shareText": "Salut !\n\nJ’utilise Partage Agricole, une app pour partager des objets du quotidien. C’est super pratique et je suis sûr·e que tu vas aimer. Rejoins-moi :\n\n{{url}}"
    },
    "referralProgram202506": {
      "shareText": "Salut !\n\nJ’utilise Partage Agricole, une app pour partager des objets du quotidien. C’est super pratique et je suis sûr·e que tu vas aimer. Rejoins-moi :\n\n{{url}}"
    },
    "shareText": "Salut !\n\nJ’utilise Partage Agricole, une app pour partager des objets du quotidien. C’est super pratique et je suis sûr·e que tu vas aimer. Rejoins-moi :\n\n{{url}}",
    "title": "Invite les autres membres ou tes proches !"
  },
  "landing-page": {
    "immature": {
      "referral": {
        "button": "Invite les autres membres"
      }
    },
    "requests": {
      "emptyState": {
        "subtitle": "Nous te préviendrons si les autres membres ont besoin d’aide"
      }
    }
  },
  "loans": {
    "past": {
      "savings": {
        "header": {
          "lending": "Économisé par les autres membres grâce à toi"
        }
      }
    }
  },
  "my-impact-financial": {
    "empty": {
      "lending": {
        "secondLine": "Partage tes objets et vois combien d'argent tu permets aux membres d'économiser !"
      }
    },
    "emptyByTransaction": {
      "lend": {
        "lending": {
          "secondLine": "Partage tes objets et vois combien d'argent tu permets aux membres d'économiser !"
        }
      }
    }
  },
  "my-neighbourhood": {
    "radiusDescription": "Ton rayon te permet de partager tes annonces dans un périmètre limité de ton quartier. Les membres habitant hors de cette zone ne pourront pas voir tes annonces."
  },
  "one-channel": {
    "howItWorks": {
      "borrow": {
        "step2": "<bold>Propose</bold> des dates d'emprunt, <bold>attends la confirmation</bold> de l’autre membre puis <bold>planifiez le ramassage</bold> ensemble",
        "step3": "<bold>Récupère l'objet</bold> chez l’autre membre ou dans un lieu public sécuritaire. <bold>Aucun échange d'argent, c'est gratuit !</bold>"
      },
      "lend": {
        "step3": "<bold>Prête l'objet</bold> à l’autre membre. <bold>Aucun échange d'argent, c'est gratuit !</bold>"
      }
    }
  },
  "payment": {
    "modal": {
      "firstParagraph": "Merci de ta confiance. Grâce à ton abonnement, tu peux maintenant emprunter et prêter des objets aux autres membres sans limite."
    }
  },
  "posts": {
    "feed": {
      "endOfFeed": {
        "description": "Un objet emprunté, une belle rencontre…\nPartage ton histoire avec les autres membres."
      }
    },
    "storyComposer": {
      "neighbour": "un membre"
    }
  },
  "presentCommunity": {
    "newFlow": {
      "oneFreeBorrowDescription": "Emprunte ton premier objet aux autres membres gratuitement",
      "unlimitedLendingDescription": "Publie des offres et prête tes objets aux autres membres autant de fois que tu le souhaites"
    }
  },
  "presentPartageClub": {
    "community": {
      "headerText": "Partage Agricole, c'est l'application de <strong>partage d'objets</strong> entre membres."
    }
  },
  "profile-overview": {
    "inviteNeighboursButtonLabel": "Inviter des membres"
  },
  "recommendations": {
    "urgent-needs": {
      "title": "Aide les autres membres !"
    }
  },
  "streak": {
    "contributions": {
      "add_avatar": {
        "description": "Une photo de profil rassure les autres membres et te rend reconnaissable dans le quartier."
      },
      "dismiss_request": {
        "title": "Essaye d'aider les autres membres"
      },
      "publish_offer": {
        "description": "Publie un objet spécifique, ou choisis parmi les objets suggérés, déjà proposés par les autres membres !"
      },
      "send_message": {
        "description": "Brise la glace! Écris à un membre pour proposer ton aide ou en savoir plus sur une annonce."
      }
    },
    "neighbourhoodFirstShare": "Dans ton quartier, <strong>{{percent}}% des autres membres</strong> ont fait leur premier partage <strong>en moins d'une semaine</strong>.",
    "objectiveDetails": "L’objectif du mois est déterminé en fonction du nombre de membres partageur·euse·s autour de toi et de la maturité de ton quartier.",
    "seriesDetails": "Pour garder la flamme du partage active, toi et les autres membres devez atteindre l’objectif de partages indiqué pour le mois.",
    "tips": {
      "helpNeighbours": {
        "title": "Essaye d'aider les autres membres"
      }
    }
  }
}
